// internal deps
import { GlobalHeaderState } from "@swiggy-private/checkout-core";
import { LocalStorage, randomStringIdGenerator } from "@swiggy-private/core-ui";

// constants
import { DO_STORAGE_CART_KEY } from "@dineout-cart-client/constants/Constants";

export const PAYMENT_LINK_ID_LENGTH = 16;

/**
 * Builds a fixed-width correlator. `randomStringIdGenerator(n)` does not return
 * `n` characters (it hex-encodes 10^n), so we concatenate chunks and slice.
 */
export const generatePaymentLinkId = (length = PAYMENT_LINK_ID_LENGTH): string => {
    let paymentLink = "";
    while (paymentLink.length < length) {
        paymentLink += randomStringIdGenerator();
    }
    return paymentLink.slice(0, length);
};

/**
 * Client-generated payment link correlator. Replaces the deprecated
 * payment-link/serviceLine API. Sets cartkey for GPO and persists for webview refresh.
 */
export const createAndPersistPaymentLink = (): string => {
    const paymentLink = generatePaymentLinkId(PAYMENT_LINK_ID_LENGTH);
    GlobalHeaderState.updateHeaders({ cartkey: paymentLink });
    LocalStorage.setItem(DO_STORAGE_CART_KEY, paymentLink);
    return paymentLink;
};
